// extracted by mini-css-extract-plugin
export var contentWrapper = "ArticleImageQuoteBlock-module--contentWrapper--3a7gR";
export var authorSection = "ArticleImageQuoteBlock-module--authorSection--3kh6h";
export var authorImage = "ArticleImageQuoteBlock-module--authorImage--2ArBS";
export var authorName = "ArticleImageQuoteBlock-module--authorName--3lqK6";
export var authorOccupation = "ArticleImageQuoteBlock-module--authorOccupation--24Y96";
export var quote = "ArticleImageQuoteBlock-module--quote--3l2Vo";